import "core-js/modules/es.array.push.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { normalizeStyle as _normalizeStyle, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "product-select"
};
const _hoisted_2 = {
  class: "product-select-content"
};
const _hoisted_3 = {
  class: "product-picture"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "asin-list-box"
};
const _hoisted_6 = {
  class: "asin-list-box-content"
};
const _hoisted_7 = {
  class: "asin-list"
};
const _hoisted_8 = {
  key: 2,
  class: "subtraction-tag"
};
import { ref, computed, onMounted, toRaw, watch, inject, onActivated, nextTick } from 'vue';
import { useStore } from 'vuex';
import { showToast } from 'vant';
import BuyNow from './BuyNow.vue';
import constants, { encryptedMarketplaceId } from '@/constants';
import { useRouter } from 'vue-router';
import { Bridge } from '@/utils/bridge';
import { useLess } from '@/models/hooks';
import PopUp from '@/components/popup/PopUp.vue';
import BuyAsinList from './BuyAsinList.vue';
import BuyTopBanner from './BuyTopBanner.vue';
import BuyDeliveryInfo from './BuyDeliveryInfo.vue';
import BuyQuantity from './BuyQuantity.vue';
import BuyAccountingBox from './BuyAccountingBox.vue';
import { getAsinDetail } from '@/models/api/detailPageApi';
import spcBuyBox from '@/views/spc/orderConfirm/components/BuyBox.vue';
import spcPaymentBox from '@/views/spc/orderConfirm/components/SPCPaymentBox.vue';
import spcAccountingBox from '@/views/spc/orderConfirm/components/SPCAccountingBox.vue';
import ShoppingAuthorizationPopup from '@/views/spc/orderConfirm/components/ShoppingAuthorizationPopup.vue';
import errorPop from '@/views/spc/orderConfirm/components/SPCErrorPop.vue';
import { batchList, handleChunkArr, allProps, TWISTER_DIMENSION } from './BuyingOptionsPopup';
import { createPurchase, prepay, signPurchaseV2 } from '@/models/api/orderConfirmApi';
import { priceCalc, errorHandle as errorHandleText, handleAddressInfo, filterAndResortKnownCVs, apiType, errorTypes, getIsPlaceOrder, handleAssociateToken } from '@/views/spc/spcUtils';
import { getTwisterByAsin, addCartList, generateRandomString, getAddressList as getAddressListAndInfo, calcMultiplicative } from '@/utils/common';
import { useI18n } from 'vue-i18n';
import { get, cloneDeep, some, isNil, filter, every, clone } from 'lodash-es';
import SkuCalculator from '@leeboyin/sku-calculator';
import imageLink from '@/configs/imageLink';
import { awsRumHandler } from '@/utils/awsRumHandler.js';
import { clickEvents } from '@/configs/awsRumConfig';
export default {
  __name: 'BuyingOptionsPopup',
  props: {
    ...allProps
  },
  emits: ['update:isShowPopup', 'onConfirm', 'onPaying', 'onSelected', 'onClose', 'update:quantity', 'reloadingData'],
  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    useLess('components/BuyingOptionsPopup.less');
    const {
      NO_DATA_IMAGE
    } = imageLink;
    const {
      DEFAULT_KOL,
      PAYMENT_LIST,
      NEW_IMAGE_URL,
      PAY_STATUS_RESULT,
      CV_QUANTITY_LIMITS,
      NON_RETURNABLE_FLAG,
      CV_CONSENT_NOT_GRANT,
      TWISTER_DIMESIN_KEYS,
      GSAPP,
      CV_ADDRESS_NOT_REACHED,
      USER_INTERACTION_METHOD,
      CV_LEGACY_ADDRESS_IN_USE,
      AVAILABILITY_STATUS_ENUM,
      CV_QUANTITY_NOT_AVAILABLE,
      CV_INVALID_COUPON_BALANCE,
      ADD_CART_AND_FAVORITES_STATUS,
      CV_CUSTOMER_CONSENT_NOT_GRATED,
      ORDER_EXTERNAL_REQUEST_ID_LENGTH
    } = constants;
    const store = useStore();
    const router = useRouter();
    const {
      t,
      te
    } = useI18n();
    const BUTTON_TYPE = {
      NORMAL_BTN: 'normalBtn',
      // Display single button OK
      DOUBLE_BTN: 'doubleBtn',
      // Display double button
      TO_PAY: 'toPay' // Go to pay
    };

    const isLoading = ref(false);
    const isShowAuthorize = ref(false);
    const isOverQuantityLimit = ref(false);
    const errorPopRef = ref(null);
    const isNewCustomer = ref(false);
    // Has payment been triggered
    const hasSigned = ref(false);
    const purchaseId = ref(null);
    const addressInfo = ref(null);
    const associateToken = inject('associateToken', null);
    const cptCheckoutStatus = computed(() => {
      var _ref;
      return (_ref = addressInfo.value !== null) !== null && _ref !== void 0 ? _ref : false;
    });
    const btnStyle = ref(BUTTON_TYPE.NORMAL_BTN);
    const getBtnStyle = () => {
      let type = BUTTON_TYPE.NORMAL_BTN;
      if (props.isAddToCart && !props.isFromAsinList || !props.isAddToCart && !cptCheckoutStatus.value && !props.isFromAsinList) {
        // Add asin to shopping cart and is not in the asin list  || Not  adding asin to shopping cart without an address and not in the asin list
        type = BUTTON_TYPE.NORMAL_BTN;
      } else if (props.isFromAsinList) {
        // In the asin list
        type = BUTTON_TYPE.DOUBLE_BTN;
      } else if (!props.isAddToCart && cptCheckoutStatus.value) {
        // Not adding asin to shopping cart and having an address
        type = BUTTON_TYPE.TO_PAY;
      }
      btnStyle.value = type;
    };
    const isPayButtonDisabled = computed(() => {
      return addressInfo.value !== null && store.state.checkout.fillKYC !== null;
    });
    const asinDetails = ref({
      specificationText: ''
    });
    const popHeight = computed(() => {
      return btnStyle.value === BUTTON_TYPE.TO_PAY ? '85%' : '72%';
    });
    const distanceFromBottom = computed(() => {
      var _ref2, _store$state$navigato;
      return (_ref2 = `${Number((_store$state$navigato = store.state.navigator.agentData) === null || _store$state$navigato === void 0 ? void 0 : _store$state$navigato.bottom)}px`) !== null && _ref2 !== void 0 ? _ref2 : '0';
    });
    const productStylesParam = ref([]); // Specification list
    const selectedProductIndex = ref([]); // Select the item subscript
    const quantity = ref(0); // Added quantity
    const calculatedAllPrice = ref(null); // // The total price amount is calculated and displayed
    const promotions = ref(null);
    const isSeeLargeImg = ref(false); // View picture configuration

    const seeImages = ref([]);
    const twisterValue = ref(null); // Objects of all twister
    const asinsValue = ref([]); // All asins data
    const selectedTwister = ref({}); // The currently selected twister
    const twisterColorImage = ref({}); // Picture of twister
    const twisterStatus = ref(); // Status of all twister
    const statistics = ref(); // statistical data
    const deliveryInfoRef = ref(null);
    const paymentBoxRef = ref(null);
    // Selectable specification array
    let asinCalculator = null; // Instantiated object for calculating SKU
    // Selectable twister array
    const selectionArray = computed(() => {
      let selectionList = [];
      if (!every(selectedTwister.value, isNil)) {
        selectionList.push({
          spec: clone(selectedTwister.value),
          amount: 1
        });
      }
      selectionList = filter(selectionList, selection => {
        return selection.amount > 0 || some(selection.spec, value => {
          return !isNil(value);
        });
      });
      return selectionList;
    });
    const showTip = (tip, success = false) => {
      showToast({
        message: tip,
        duration: 2500,
        className: 'a-toast',
        icon: success ? constants.SUCCESS_ICON_IMAGE_URL : '',
        overlay: false,
        overlayClass: 'a-overlay-white'
      });
    };
    watch(() => selectionArray.value, () => {
      // Recalculate optional twister
      asinCalculator.setSelectionArray(selectionArray.value);
      twisterStatus.value = cloneDeep(asinCalculator.specStatus);
      statistics.value = cloneDeep(asinCalculator.statistics);
      const selectedSkuIndex = statistics.value.determinedAmount ? Object.keys(statistics.value.determinedAmount)[0] : null;
      if (selectedSkuIndex) {
        // Assign asinDetail
        asinDetails.value = asinsValue.value[selectedSkuIndex];
        if (btnStyle.value === BUTTON_TYPE.TO_PAY) {
          // eslint-disable-next-line no-use-before-define
          getPurchaseDetail();
        }
      }
      awsRumHandler.recordClickEvent(clickEvents.detailPage.chooseProductSpecificationButton);
    });
    // Check if the twister are selectable
    function isTwisterSelectable(specName, specValue) {
      return get(twisterStatus.value, [specName, specValue, 'selectable'], false) && !get(twisterStatus.value, [specName, specValue, 'insufficient'], false);
    }
    // Click on a single twister
    function onClickTwister(name, value) {
      if (!isTwisterSelectable(name, value)) {
        return;
      }
      if (selectedTwister.value[name] === value) {
        selectedTwister.value[name] = null;
      } else {
        selectedTwister.value[name] = value;
      }
    }
    const getAddressInfo = async () => {
      const {
        addressInfo: addressDefault
      } = await getAddressListAndInfo();
      addressInfo.value = addressDefault;
    };
    // Processing and calculation of settlement products
    const handlePurchaseList = (list, type = apiType.createPurchase) => {
      let importFee = 0;
      let nonReturnable = false;
      const itemList = [toRaw(asinDetails.value)];
      list.forEach(item => {
        itemList === null || itemList === void 0 ? void 0 : itemList.forEach(childItem => {
          if (item.asin === childItem.asin) {
            var _childItem$globalStor, _childItem$globalStor2;
            if (childItem.nonReturnableFlag === NON_RETURNABLE_FLAG.FALSE) {
              nonReturnable = true;
            }
            importFee += (childItem === null || childItem === void 0 ? void 0 : (_childItem$globalStor = childItem.globalStore) === null || _childItem$globalStor === void 0 ? void 0 : (_childItem$globalStor2 = _childItem$globalStor.importFee) === null || _childItem$globalStor2 === void 0 ? void 0 : _childItem$globalStor2.amount) * Number(quantity.value);
          }
        });
      });
      const value = toRaw(calculatedAllPrice.value);
      if (type === apiType.createPurchase) {
        calculatedAllPrice.value = {
          ...value,
          importFee,
          isNonReturnableTag: nonReturnable
        };
      } else {
        calculatedAllPrice.value = {
          ...value,
          isNonReturnableTag: nonReturnable
        };
      }
      return list;
    };
    // Price assignment
    const handlePurchasePrice = allPrice => {
      const {
        total,
        discount,
        importFee,
        shippingFee,
        promotionList,
        shippingDiscount,
        shippingPromotion
      } = allPrice;
      store.commit('checkout/setDiscount', -discount);
      const totalPrice = total + importFee + shippingFee + discount;
      store.commit('checkout/setTotalPrice', totalPrice);
      calculatedAllPrice.value = {
        ...toRaw(calculatedAllPrice.value),
        total,
        importFee,
        shippingPromotion,
        originalShippingFee: shippingFee,
        discount: -(discount - shippingDiscount),
        shippingFee: shippingFee + shippingDiscount,
        promotionList: Array.from(promotionList.values())
      };
    };

    // View Details Invoke the creation order interface to obtain the money details of the selected data
    const getPurchaseDetail = async () => {
      isLoading.value = true;
      const associatesInfo = associateToken !== null && associateToken !== void 0 && associateToken.value ? handleAssociateToken(associateToken.value, asinDetails.value.merchantId) : false;
      const payList = [{
        asin: asinDetails.value.asin,
        quantity: Number(quantity.value),
        asinDetail: {
          merchantId: asinDetails.value.merchantId
        },
        ...(associatesInfo && {
          associatesInfo
        })
      }];
      try {
        const {
          data
        } = await createPurchase({
          ...(addressInfo.value && {
            addressInfo: handleAddressInfo(addressInfo.value)
          }),
          items: payList,
          externalPlatform: GSAPP,
          externalSellerId: DEFAULT_KOL,
          purchaseSessionId: '457-9196418-2840651',
          // API issue, temporarily using fixed values
          requestId: generateRandomString(ORDER_EXTERNAL_REQUEST_ID_LENGTH),
          suppressPrice: false
        });
        purchaseId.value = data.purchaseId;
        store.commit('checkout/setPurchaseId', data.purchaseId);
        const {
          list,
          allPrice
        } = priceCalc(data === null || data === void 0 ? void 0 : data.orderDetailList);
        handlePurchaseList(list, apiType.createPurchase);
        handlePurchasePrice(allPrice);
        store.commit('checkout/setAddressId', data === null || data === void 0 ? void 0 : data.obfuscatedAddressId);
        if (data !== null && data !== void 0 && data.kycItemModel) {
          var _data$kycItemModel, _data$kycItemModel2, _data$kycItemModel3;
          store.commit('checkout/setFillKYC', {
            maskedId: (_data$kycItemModel = data.kycItemModel) === null || _data$kycItemModel === void 0 ? void 0 : _data$kycItemModel.maskedId,
            kycId: (_data$kycItemModel2 = data.kycItemModel) === null || _data$kycItemModel2 === void 0 ? void 0 : _data$kycItemModel2.kycId,
            holderName: (_data$kycItemModel3 = data.kycItemModel) === null || _data$kycItemModel3 === void 0 ? void 0 : _data$kycItemModel3.holderName,
            maskedPhoneNumber: data === null || data === void 0 ? void 0 : data.maskedPhoneNumber,
            frontCitizenUploadToken: data === null || data === void 0 ? void 0 : data.frontCitizenUploadToken,
            backCitizenUploadToken: data === null || data === void 0 ? void 0 : data.backCitizenUploadToken
          });
        }
      } catch (error) {
        isLoading.value = false;
        showTip(t('modules.checkout.FAILED_TO_CREATE_ORDER'));
      } finally {
        isLoading.value = false;
      }
    };
    const getSelectedAsinDetail = async (selectedAsin = props.selectedAsin) => {
      var _currentValue$asinTex, _data$twisterVariatio, _data$twisterVariatio2, _skus$find$spec, _skus$find;
      isLoading.value = true;
      productStylesParam.value = [];
      const {
        data
      } = await getAsinDetail({
        id: selectedAsin,
        marketplace: encryptedMarketplaceId,
        allowOtherOffer: true,
        merchantId: props.merchantId
      });
      if (!data.stockOnHand) {
        var _errorPopRef$value;
        isLoading.value = false;
        errorPopRef === null || errorPopRef === void 0 ? void 0 : (_errorPopRef$value = errorPopRef.value) === null || _errorPopRef$value === void 0 ? void 0 : _errorPopRef$value.errorfn(errorTypes.ALL_OUT_OF_STOCK);
        return;
      }
      asinDetails.value = JSON.parse(JSON.stringify(data));
      const currentValue = getTwisterByAsin(data);
      asinDetails.value.specificationText = (_currentValue$asinTex = currentValue === null || currentValue === void 0 ? void 0 : currentValue.asinText) !== null && _currentValue$asinTex !== void 0 ? _currentValue$asinTex : '';
      selectedProductIndex.value = currentValue.values;
      if (!((_data$twisterVariatio = data.twisterVariations) !== null && _data$twisterVariatio !== void 0 && _data$twisterVariatio.dimensionKeys) || !((_data$twisterVariatio2 = data.twisterVariations) !== null && _data$twisterVariatio2 !== void 0 && _data$twisterVariatio2.dimensionValues)) {
        isLoading.value = false;
        if (btnStyle.value === BUTTON_TYPE.TO_PAY) {
          await getPurchaseDetail();
        }
        return;
      }
      const specs = {};
      const dimensionKeys = data.twisterVariations.dimensionKeys;
      const dimensionValues = data.twisterVariations.dimensionValues;
      const variations = data.twisterVariations.variations; // Obtain all ASIN numbers and combinations from the API
      dimensionValues.forEach((item, index) => {
        const keys = dimensionKeys[index].symbol;
        specs[keys] = item;
      });
      twisterValue.value = specs;
      const skus = [];
      const asinList = [];
      variations.forEach(item => {
        const spec = {};
        item.values.forEach((specItem, specIndex) => {
          const keys = dimensionKeys[specIndex].symbol;
          const value = dimensionValues[specIndex][specItem];
          spec[keys] = value;
        });
        // Filter out dirty data
        if (dimensionValues.length === item.values.length) {
          skus.push({
            spec,
            asin: item.asin,
            values: item.values
          });
          asinList.push(item.asin);
        }
      });
      // Obtain ASIN details
      const chunkPromiselist = handleChunkArr(asinList);
      const batchPromiselist = [];
      chunkPromiselist.forEach(item => {
        batchPromiselist.push(batchList(item.join()));
      });
      const batchData = await Promise.all(batchPromiselist);
      const allResult = batchData.flat(1);
      allResult.forEach(result => {
        skus.forEach(sku => {
          if (sku.asin === result.asin) {
            Object.assign(sku, result, {
              amount: result.stockOnHand
            });
          }
        });
      });
      asinsValue.value = skus;
      asinCalculator = new SkuCalculator({
        specs,
        skus,
        hasAmount: true
      });
      twisterStatus.value = asinCalculator.specStatus;
      statistics.value = asinCalculator.statistics;
      // Obtain the currently selected Twister value
      const currentTwisterValue = (_skus$find$spec = (_skus$find = skus.find(item => item.asin === selectedAsin)) === null || _skus$find === void 0 ? void 0 : _skus$find.spec) !== null && _skus$find$spec !== void 0 ? _skus$find$spec : [];
      Object.entries(currentTwisterValue).forEach(item => {
        onClickTwister(item[0], item[1]);
      });
      // Get images of all colors
      const colorImg = {};
      skus.forEach(item => {
        var _specs$color_name;
        specs === null || specs === void 0 ? void 0 : (_specs$color_name = specs.color_name) === null || _specs$color_name === void 0 ? void 0 : _specs$color_name.forEach(i => {
          if (i === item.spec.color_name && item !== null && item !== void 0 && item.mainImage) {
            if (!(colorImg !== null && colorImg !== void 0 && colorImg[item.spec.color_name])) {
              colorImg[item.spec.color_name] = item === null || item === void 0 ? void 0 : item.mainImage;
            }
          }
        });
      });
      twisterColorImage.value = colorImg;
      isLoading.value = false;
      if (btnStyle.value === BUTTON_TYPE.TO_PAY) {
        await getPurchaseDetail();
      }
    };
    const changeAddress = () => {
      getPurchaseDetail();
    };
    const quantityChange = async () => {
      emits('update:quantity', quantity.value);
      if (btnStyle.value === BUTTON_TYPE.TO_PAY) {
        var _asinDetails$value;
        if (!((_asinDetails$value = asinDetails.value) !== null && _asinDetails$value !== void 0 && _asinDetails$value.asin)) return;
        await getPurchaseDetail();
      }
    };
    const errorHandleFn = {
      allOutOfStock: async () => {
        emits('update:isShowPopup', false);
        emits('reloadingData');
      }
    };
    // Errors returned by public processing APIs
    const handleErrorReason = error => {
      var _error$checkOutErrorD;
      if ((error === null || error === void 0 ? void 0 : (_error$checkOutErrorD = error.checkOutErrorDetailModelList) === null || _error$checkOutErrorD === void 0 ? void 0 : _error$checkOutErrorD.length) > 0) {
        var _error$checkOutErrorD2;
        const errorDetail = error === null || error === void 0 ? void 0 : (_error$checkOutErrorD2 = error.checkOutErrorDetailModelList[0]) === null || _error$checkOutErrorD2 === void 0 ? void 0 : _error$checkOutErrorD2.reason;
        if (errorDetail === CV_LEGACY_ADDRESS_IN_USE || errorDetail === CV_ADDRESS_NOT_REACHED) {
          return true; // Address anomaly
        }

        if (errorDetail === CV_CONSENT_NOT_GRANT || errorDetail === CV_CUSTOMER_CONSENT_NOT_GRATED) {
          isShowAuthorize.value = true; // unauthorized
          return true;
        }
        if (errorDetail === CV_QUANTITY_LIMITS) {
          var _error$checkOutErrorD3, _error$checkOutErrorD4, _error$checkOutErrorD5;
          // quantity limit
          const quantityErr = (_error$checkOutErrorD3 = error === null || error === void 0 ? void 0 : (_error$checkOutErrorD4 = error.checkOutErrorDetailModelList[0]) === null || _error$checkOutErrorD4 === void 0 ? void 0 : (_error$checkOutErrorD5 = _error$checkOutErrorD4.errorQuantityContext) === null || _error$checkOutErrorD5 === void 0 ? void 0 : _error$checkOutErrorD5.QuantityPurchasable) !== null && _error$checkOutErrorD3 !== void 0 ? _error$checkOutErrorD3 : 0;
          if (quantityErr > 1) {
            isOverQuantityLimit.value = true;
            quantity.value = quantityErr;
            showTip(errorHandleText.overQuantityLimit.tipErrorText);
          } else {
            var _errorPopRef$value2;
            errorPopRef === null || errorPopRef === void 0 ? void 0 : (_errorPopRef$value2 = errorPopRef.value) === null || _errorPopRef$value2 === void 0 ? void 0 : _errorPopRef$value2.errorfn(errorTypes.ALL_OUT_OF_STOCK);
          }
          return true;
        }
        if (errorDetail === CV_QUANTITY_NOT_AVAILABLE) {
          var _errorPopRef$value3;
          errorPopRef === null || errorPopRef === void 0 ? void 0 : (_errorPopRef$value3 = errorPopRef.value) === null || _errorPopRef$value3 === void 0 ? void 0 : _errorPopRef$value3.errorfn(errorTypes.ALL_OUT_OF_STOCK);
          return true;
        }
        if (errorDetail === CV_INVALID_COUPON_BALANCE) {
          var _errorPopRef$value4;
          errorPopRef === null || errorPopRef === void 0 ? void 0 : (_errorPopRef$value4 = errorPopRef.value) === null || _errorPopRef$value4 === void 0 ? void 0 : _errorPopRef$value4.errorfn(errorTypes.INVALID_COUPON);
          return true;
        }
      }
      return false;
    };
    const prePay = async () => {
      store.commit('checkout/setFromPage', asinDetails.value.asin);
      try {
        isLoading.value = true;
        const {
          data: payData
        } = await prepay({
          userInteractionMethod: USER_INTERACTION_METHOD,
          externalPlatform: GSAPP,
          purchaseId: purchaseId.value,
          requestId: generateRandomString(ORDER_EXTERNAL_REQUEST_ID_LENGTH)
        });
        isLoading.value = false;
        emits('update:isShowPopup', false);
        const {
          result: payResult
        } = await Bridge.callFnVal('payOrder', {
          payType: PAYMENT_LIST[0].type,
          payData: payData === null || payData === void 0 ? void 0 : payData.redirectParameters
        });
        // pay success
        if (payResult === PAY_STATUS_RESULT.PAYSUCCESS) {
          if (isNewCustomer.value) {
            Bridge.callFnVal('changeCurrentCustomerActualPurchaseStatus', {
              hasActualPurchase: true
            });
            const orderPrice = calcMultiplicative(store.state.checkout.totalPrice.toFixed(2), 100);
            Bridge.callFnVal('reportEventToServer', {
              eventType: 'placeOrder',
              eventData: JSON.stringify({
                orderPrice
              })
            });
            Bridge.callFnVal('reportPayOrderToTalkingData', {
              orderId: purchaseId.value,
              total: orderPrice,
              paymentType: PAYMENT_LIST[0].type
            });
          }
          router.replace({
            name: 'paySuccess'
          });
        } else if (payResult === PAY_STATUS_RESULT.ABNORMAL) {
          router.replace({
            name: 'payAbnormal'
          });
        } else {
          // pay fail
          router.replace({
            name: 'payFail'
          });
        }
      } catch (error) {
        isLoading.value = false;
        showTip(t('modules.checkout.MAXIMUM_PAYMENT_LIMIT_EXCEEDED'));
      }
    };
    // Handling situations where ASIN is not selected
    const handleNotSelectedAsin = () => {
      const notSelectedIndex = Object.entries(selectedTwister.value).findIndex(i => i[1] === null);
      if (notSelectedIndex !== -1) {
        const noSelectedTwister = Object.entries(selectedTwister.value)[notSelectedIndex][0];
        const tipText = `${t('modules.checkout.PLEASE_SELECT')}${te(`modules.checkout.${TWISTER_DIMENSION[noSelectedTwister]}`) ? t(`modules.checkout.${TWISTER_DIMENSION[noSelectedTwister]}`) : noSelectedTwister}`;
        showTip(tipText);
        return false;
      }
      return true;
    };
    const getIsStockOnHand = async () => {
      const {
        data
      } = await getAsinDetail({
        id: asinDetails.value.asin,
        marketplace: encryptedMarketplaceId,
        allowOtherOffer: true,
        merchantId: props.merchantId
      });
      if (!data.stockOnHand) {
        var _errorPopRef$value5;
        errorPopRef === null || errorPopRef === void 0 ? void 0 : (_errorPopRef$value5 = errorPopRef.value) === null || _errorPopRef$value5 === void 0 ? void 0 : _errorPopRef$value5.errorfn(errorTypes.ALL_OUT_OF_STOCK);
        return false;
      }
      return true;
    };
    const checkPay = () => {
      if (!addressInfo.value) {
        showTip(t('modules.checkout.PLEASE_FILL_SHIPPING_ADDRESS'));
        return;
      }
      if (!store.state.checkout.fillKYC) {
        showTip(t('modules.checkout.PLEASE_PROVIDE_KYC'));
      }
    };
    const handelPay = async () => {
      if (!handleNotSelectedAsin()) return;
      if (!(await getIsStockOnHand())) return;
      const {
        isPlaceOrder,
        title,
        content
      } = await getIsPlaceOrder();
      if (!isPlaceOrder) {
        var _errorPopRef$value6;
        errorPopRef === null || errorPopRef === void 0 ? void 0 : (_errorPopRef$value6 = errorPopRef.value) === null || _errorPopRef$value6 === void 0 ? void 0 : _errorPopRef$value6.errorfn(errorTypes.NOT_PLACE_ORDER, title, content);
        return;
      }
      const {
        result: hasWeChat
      } = await Bridge.callFnVal('checkWeChatAppHasInstalled');
      if (!hasWeChat) {
        var _errorPopRef$value7;
        errorPopRef === null || errorPopRef === void 0 ? void 0 : (_errorPopRef$value7 = errorPopRef.value) === null || _errorPopRef$value7 === void 0 ? void 0 : _errorPopRef$value7.errorfn(errorTypes.UNINSTALL_WECHAT);
        return;
      }
      isLoading.value = true;
      try {
        if (!hasSigned.value) {
          await signPurchaseV2({
            externalPlatform: GSAPP,
            externalSellerId: DEFAULT_KOL,
            purchaseId: purchaseId.value,
            requestId: generateRandomString(ORDER_EXTERNAL_REQUEST_ID_LENGTH)
          });
          hasSigned.value = true;
          await prePay();
          Bridge.callFnVal('clearAssociateToken');
        } else {
          await prePay();
        }
      } catch (error) {
        var _error$data, _error$data$CVList;
        isLoading.value = false;
        showTip(t('modules.checkout.FAILED_TO_CREATE_ORDER'));
        if (handleErrorReason(error === null || error === void 0 ? void 0 : error.data)) return;
        if ((error === null || error === void 0 ? void 0 : (_error$data = error.data) === null || _error$data === void 0 ? void 0 : (_error$data$CVList = _error$data.CVList) === null || _error$data$CVList === void 0 ? void 0 : _error$data$CVList.length) > 0) {
          let vipCV = null;
          const sortedCVs = filterAndResortKnownCVs(error === null || error === void 0 ? void 0 : error.data.CVList);
          if ((sortedCVs === null || sortedCVs === void 0 ? void 0 : sortedCVs.length) > 0) {
            var _vipCV;
            vipCV = sortedCVs[0].cv;
            if ((_vipCV = vipCV) !== null && _vipCV !== void 0 && _vipCV.reason) {
              var _errorPopRef$value8;
              errorPopRef === null || errorPopRef === void 0 ? void 0 : (_errorPopRef$value8 = errorPopRef.value) === null || _errorPopRef$value8 === void 0 ? void 0 : _errorPopRef$value8.errorfn(errorTypes.UNKNOWN_FAIL);
            }
          }
        }
      } finally {
        isLoading.value = false;
      }
    };

    //  Add to cart
    const onAddCart = async () => {
      if (!handleNotSelectedAsin()) return;
      const asin = asinDetails.value.asin;
      awsRumHandler.recordClickEvent({
        ...clickEvents.detailPage.addToCartButton,
        asinid: asin
      });
      if (props.isProductReplace) {
        await Bridge.callFnVal('deleteShoppingCartList', {
          asins: [props.selectedAsin]
        });
      }
      addCartList(asin, props.merchantId, quantity.value, true, res => {
        showTip(t('modules.checkout.SUCCESS_ADD_CART'), true);
        emits('update:isShowPopup', false);
        emits('onConfirm', res);
      });
    };

    // Go to pay
    const onPaying = async () => {
      if (!handleNotSelectedAsin()) return;
      if (!(await getIsStockOnHand())) return;
      store.commit('checkout/setCheckoutItemList', [{
        count: quantity.value,
        productItem: asinDetails.value
      }]);
      store.commit('checkout/setFromPage', asinDetails.value.asin);
      Bridge.callFn('saveDataToMemoryCache', {
        key: 'checkoutList',
        value: [{
          count: quantity.value,
          productItem: asinDetails.value,
          ...((associateToken === null || associateToken === void 0 ? void 0 : associateToken.value) && {
            associateToken: associateToken.value
          })
        }]
      });
      emits('update:isShowPopup', false);
      store.commit('checkout/setIsNewCustomerGuidePopupOpened', false);
      router.push({
        name: 'orderConfirm',
        params: {
          from: asinDetails.value.asin
        }
      });
    };
    const onClose = () => {
      emits('onClose', asinDetails.value);
      emits('update:isShowPopup', false);
    };
    // View picture
    const seeLargeImg = url => {
      isSeeLargeImg.value = true;
      seeImages.value = [url];
    };

    // If there is a change in isCloseBuyingOptionsPopup, actively close the current component
    watch(() => store.state.cart.isCloseBuyingOptionsPopup, () => {
      emits('update:isShowPopup', false);
    });
    onMounted(async () => {
      await getAddressInfo();
      getBtnStyle();
      asinDetails.value = {
        specificationText: ''
      };
      getSelectedAsinDetail();
      quantity.value = props.quantity;
    });
    onActivated(async () => {
      var _deliveryInfoRef$valu;
      await ((_deliveryInfoRef$valu = deliveryInfoRef.value) === null || _deliveryInfoRef$valu === void 0 ? void 0 : _deliveryInfoRef$valu.getAddressList());
      await nextTick(async () => {
        if (btnStyle.value === BUTTON_TYPE.TO_PAY) {
          var _store$state$checkout, _addressInfo$value;
          if (((_store$state$checkout = store.state.checkout.fillAddress) === null || _store$state$checkout === void 0 ? void 0 : _store$state$checkout.id) === ((_addressInfo$value = addressInfo.value) === null || _addressInfo$value === void 0 ? void 0 : _addressInfo$value.id) || store.state.checkout.isAddAddress) {
            addressInfo.value = store.state.checkout.fillAddress;
          }
          await getPurchaseDetail();
          await paymentBoxRef.value.getKycInfo();
        }
      });
    });
    return (_ctx, _cache) => {
      const _component_van_image_preview = _resolveComponent("van-image-preview");
      const _component_van_popup = _resolveComponent("van-popup");
      const _directive_lazy = _resolveDirective("lazy");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_van_popup, {
        show: _ctx.isShowPopup,
        closeable: "",
        round: "",
        position: "bottom",
        style: _normalizeStyle({
          height: popHeight.value,
          width: '100%',
          marginBottom: _ctx.marginBottom + 'px'
        }),
        "close-icon": "cross",
        "close-on-popstate": true,
        onClose: onClose,
        "overlay-class": "a-overlay"
      }, {
        default: _withCtx(() => {
          var _asinDetails$value2, _asinDetails$value3, _asinDetails$value5, _calculatedAllPrice$v, _calculatedAllPrice$v2, _asinDetails$value6, _promotions$value;
          return [_createVNode(BuyTopBanner, {
            popHeight: popHeight.value,
            asinDetails: asinDetails.value,
            style: _normalizeStyle({
              marginBottom: _ctx.marginBottom + 'px'
            })
          }, null, 8, ["popHeight", "asinDetails", "style"]), _withDirectives((_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["buying-options-popup", {
              'pay-pop': btnStyle.value === BUTTON_TYPE.TO_PAY
            }])
          }, [btnStyle.value == BUTTON_TYPE.TO_PAY ? (_openBlock(), _createBlock(BuyDeliveryInfo, {
            key: 0,
            isLoading: isLoading.value,
            onChangeAddress: changeAddress,
            addressInfo: addressInfo.value,
            "onUpdate:addressInfo": _cache[0] || (_cache[0] = $event => addressInfo.value = $event),
            asinDetails: asinDetails.value,
            ref_key: "deliveryInfoRef",
            ref: deliveryInfoRef
          }, null, 8, ["isLoading", "addressInfo", "asinDetails"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_asinDetails$value2 = asinDetails.value) !== null && _asinDetails$value2 !== void 0 && _asinDetails$value2.mainImage ? _withDirectives((_openBlock(), _createElementBlock("img", {
            key: (_asinDetails$value3 = asinDetails.value) === null || _asinDetails$value3 === void 0 ? void 0 : _asinDetails$value3.mainImage,
            onClick: _cache[1] || (_cache[1] = $event => {
              var _asinDetails$value4;
              return seeLargeImg((_asinDetails$value4 = asinDetails.value) === null || _asinDetails$value4 === void 0 ? void 0 : _asinDetails$value4.mainImage);
            }),
            alt: ""
          })), [[_directive_lazy, (_asinDetails$value5 = asinDetails.value) === null || _asinDetails$value5 === void 0 ? void 0 : _asinDetails$value5.mainImage]]) : (_openBlock(), _createElementBlock("img", {
            key: 1,
            src: _unref(NO_DATA_IMAGE),
            alt: ""
          }, null, 8, _hoisted_4))]), _createVNode(BuyAccountingBox, {
            asinDetails: asinDetails.value,
            promotions: promotions.value,
            quantity: quantity.value,
            promotionInfoList: _ctx.promotionInfoList,
            selectedTwister: selectedTwister.value
          }, null, 8, ["asinDetails", "promotions", "quantity", "promotionInfoList", "selectedTwister"])])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(BuyAsinList, {
            onSeeLargeImg: seeLargeImg,
            asinDetails: asinDetails.value,
            twisterStatus: twisterStatus.value,
            twisterValue: twisterValue.value,
            selectedTwister: selectedTwister.value,
            twisterColorImage: twisterColorImage.value,
            onOnClickTwister: onClickTwister
          }, null, 8, ["asinDetails", "twisterStatus", "twisterValue", "selectedTwister", "twisterColorImage"]), _createVNode(BuyQuantity, {
            asinDetails: asinDetails.value,
            quantity: quantity.value,
            "onUpdate:quantity": _cache[2] || (_cache[2] = $event => quantity.value = $event),
            isOverQuantityLimit: isOverQuantityLimit.value,
            onQuantityChange: quantityChange
          }, null, 8, ["asinDetails", "quantity", "isOverQuantityLimit"])]), btnStyle.value === BUTTON_TYPE.TO_PAY && calculatedAllPrice.value ? (_openBlock(), _createBlock(spcAccountingBox, {
            key: 0,
            price: calculatedAllPrice.value,
            promotions: promotions.value,
            "onUpdate:promotions": _cache[3] || (_cache[3] = $event => promotions.value = $event),
            addressInfo: addressInfo.value,
            onUpdatePurchase: getPurchaseDetail,
            isNewCustomer: isNewCustomer.value,
            "onUpdate:isNewCustomer": _cache[4] || (_cache[4] = $event => isNewCustomer.value = $event)
          }, null, 8, ["price", "promotions", "addressInfo", "isNewCustomer"])) : _createCommentVNode("", true), btnStyle.value === BUTTON_TYPE.TO_PAY && calculatedAllPrice.value ? (_openBlock(), _createBlock(spcPaymentBox, {
            key: 1,
            price: calculatedAllPrice.value,
            onHandleCompleteKyc: getPurchaseDetail,
            ref_key: "paymentBoxRef",
            ref: paymentBoxRef
          }, null, 8, ["price"])) : _createCommentVNode("", true)])]), _createElementVNode("div", {
            class: "buying-box",
            style: _normalizeStyle({
              paddingBottom: distanceFromBottom.value
            })
          }, [btnStyle.value === BUTTON_TYPE.TO_PAY ? (_openBlock(), _createBlock(spcBuyBox, {
            key: 0,
            onPay: handelPay,
            onCheckPay: checkPay,
            isPayButtonDisabled: isPayButtonDisabled.value,
            isLoading: isLoading.value,
            total: (_calculatedAllPrice$v = calculatedAllPrice.value) === null || _calculatedAllPrice$v === void 0 ? void 0 : _calculatedAllPrice$v.total,
            nums: quantity.value,
            nonReturnableTag: (_calculatedAllPrice$v2 = calculatedAllPrice.value) === null || _calculatedAllPrice$v2 === void 0 ? void 0 : _calculatedAllPrice$v2.isNonReturnableTag,
            price: calculatedAllPrice.value,
            asinsList: [(_asinDetails$value6 = asinDetails.value) === null || _asinDetails$value6 === void 0 ? void 0 : _asinDetails$value6.asin]
          }, null, 8, ["isPayButtonDisabled", "isLoading", "total", "nums", "nonReturnableTag", "price", "asinsList"])) : (_openBlock(), _createBlock(BuyNow, {
            key: 1,
            isAddToCart: _ctx.isAddToCart,
            showBtn: btnStyle.value,
            isLoading: isLoading.value,
            asinDetails: asinDetails.value,
            promotionInfoList: _ctx.promotionInfoList,
            onOnAddCart: onAddCart,
            onOnPaying: onPaying
          }, null, 8, ["isAddToCart", "showBtn", "isLoading", "asinDetails", "promotionInfoList"])), (_promotions$value = promotions.value) !== null && _promotions$value !== void 0 && _promotions$value.text ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createTextVNode(_toDisplayString(_ctx.$t('modules.checkout.CURRENT_PRODUCT_AVAILABLE')) + "  ", 1), _createElementVNode("span", null, _toDisplayString(_unref(t)('common.REDUCTION_COUPON', {
            amount: promotions.value.threshold,
            promotion: promotions.value.amount
          })), 1)])) : _createCommentVNode("", true)], 4)], 2)), [[_directive_loading, isLoading.value]]), _createVNode(_component_van_image_preview, {
            overlayClass: "image-preview-overlay",
            show: isSeeLargeImg.value,
            "onUpdate:show": _cache[5] || (_cache[5] = $event => isSeeLargeImg.value = $event),
            images: seeImages.value,
            showIndex: false
          }, null, 8, ["show", "images"]), _createVNode(errorPop, {
            ref_key: "errorPopRef",
            ref: errorPopRef,
            errorHandleFn: errorHandleFn
          }, null, 512), _createVNode(ShoppingAuthorizationPopup, {
            show: isShowAuthorize.value,
            "onUpdate:show": _cache[6] || (_cache[6] = $event => isShowAuthorize.value = $event)
          }, null, 8, ["show"])];
        }),
        _: 1
      }, 8, ["show", "style"]);
    };
  }
};